import { render } from "./page14.vue?vue&type=template&id=4c6c463a&scoped=true"
import script from "./page14.vue?vue&type=script&lang=js"
export * from "./page14.vue?vue&type=script&lang=js"

import "./page14.vue?vue&type=style&index=0&id=4c6c463a&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6c463a"]])

export default __exports__